import { NavLink, Outlet } from "react-router";

import { Panel } from "../../components/ui/Panel";

const SECTIONS = [
  { label: "Clients", path: "/mappings", end: true },
  { label: "Techs", path: "/mappings/techs", end: false },
  { label: "Autotask settings", path: "/mappings/autotask", end: false },
  { label: "Email", path: "/mappings/email", end: false },
  // Vendors' domains and numbers, apart from Email (ADR 0198).
  { label: "Vendors", path: "/mappings/vendors", end: false },
  { label: "Network access", path: "/mappings/network", end: false },
] as const;

/**
 * Owner admin (BUILD_PLAN.md section 12): the master client table (every
 * service's names included, ADR 0078), tech mapping, the Autotask settings,
 * what email counts (ADR 0108, decision 5), the vendors whose email and calls
 * don't count (ADR 0198) and which network connections count (ADR 0158), each
 * on its own sub-page.
 */
export function MappingsPage() {
  return (
    <>
      <Panel className="flex flex-wrap items-center gap-6">
        <h1 className="text-xl font-semibold tracking-tight">Mappings</h1>
        {/* On a phone the tabs wrap, inside the window: the page never
            scrolls sideways (BUILD_PLAN 11.3). */}
        <nav aria-label="Mappings" className="flex min-w-0 flex-wrap gap-1">
          {SECTIONS.map((section) => (
            <NavLink
              key={section.path}
              to={section.path}
              end={section.end}
              className={({ isActive }) =>
                "flex h-[38px] items-center rounded-pill px-4 text-sm " +
                (isActive
                  ? "bg-brand-tint font-semibold text-brand-ink-on-tint"
                  : "font-medium text-muted hover:text-text")
              }
            >
              {section.label}
            </NavLink>
          ))}
        </nav>
      </Panel>
      <Outlet />
    </>
  );
}
